<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      盛平站<br>
站点介绍<br>
盛平站位于龙平西、东路与龙城大道交叉口，沿龙平西、东路东西向布置。车站周边地块以居住、商业、工业用地为主，西南侧有社区公园、尚景欣园小区、兴泰实验学校：东南侧主要以住宅区为主：东北侧有好万家家具装饰建材商城、盛平社区以及各住宅小区：西北侧主要以住宅小区为主。目前西侧已经实现规划，为建成区；东侧部分未实现规划，有城市更新区。车站设置有A、B、C、D4个出入口，周边以住宅为主。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:05	23:14	16号线	5分32秒	6分39秒<br>
田心	06:19	23:34	16号线	5分32秒	6分39秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:14	23:14	16号线	5分50秒	6分钟-9分钟<br>
田心	06:25	23:34	16号线	5分50秒	6分钟-9分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
大运	06:14	00:14	16号线	5分50秒	6分钟-9分钟<br>
田心	06:25	00:34	16号线	5分50秒	6分钟-9分钟<br><br>

站点出口信息<br><br>
A出入口:<br>
龙平西路、非凡空间、尚景欣园、兴泰实验学校<br><br>
B出入口:<br>
龙城大道、阳光广场、汇龙天下、育龙庭<br><br>
C出入口:<br>
龙平东路、好万家建材市场、新龙岗商业中心、馨园路、天地人和酒店、金紫薇酒店<br><br>
D出入口:<br>
龙城大道、新全盛酒店、龙岗区荔园大厦、荔枝园园式小区、悦澜山花园、全龙盛大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 尚景欣园<br>
802、B629、M276、M386、M556<br><br>
A出入口:<br>
公交站名： B出入口尚景欣园<br>
802、B629、M276、M386、M556<br><br>
A出入口:<br>
公交站名： C出入口好万家建材市场<br>
802、M276、M303、M304、M317、M386、M569<br><br>
A出入口:<br>
公交站名： D出入口欧意轩花园<br>
B629、M306、M319、M556<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shiliuhaoxian",
            title: "16号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>